import { useQuery } from '@tanstack/react-query';
import useResponseHandler from './useResponseHandler';
import { fetchPoolByHash } from '../server/requests';

const usePoolDetails = ({ poolHash, enabled = true, authHandler, userId }) => {
    const { handleResponse } = useResponseHandler({
        requestHandler: fetchPoolByHash,
        payload: { poolHash },
        authHandler,
    });

    const { status, data, error, refetch } = useQuery(
        ['pool', { poolHash, userId }],
        handleResponse,
        {
            keepPreviousData: true,
            enabled,
            retry: 0,
        }
    );

    return {
        pool: data,
        status,
        error,
        refetch,
        isPoolOwner: data?.poolTemplate?.groupOwnerId === userId,
    };
};

export const invalidatePoolShares = ({ numberOfShares, userId, pool }) => ({
    ...pool,
    shares: [
        ...pool.shares,
        {
            numberOfShares,
            userId,
            poolId: pool.poolId,
            totalAmount: numberOfShares * pool.poolSettings.sharePrice,
        },
    ],
    payout: {
        ...pool.payout,
        totalPoolAmount:
            pool.payout.totalPoolAmount +
            numberOfShares * pool.poolSettings.sharePrice,
    },
});

export default usePoolDetails;
